import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export interface NotificationState {
  notifications: Record<string, string>;
}

export interface NotificationAction {
  raiseNotification: (node: string) => void;
  clearNotification: (key: string) => void;
}

const use = create<NotificationState & NotificationAction>()(
  devtools(
    immer((set) => ({
      notifications: {},
      raiseNotification: (node: string) =>
        set(
          (state) => {
            // Use a unique identifier timestamp, to ensure each key is unique
            const notificationKey = `notification-keys-${Date.now()}`;
            state.notifications[notificationKey] = node;
          },
          false,
          { type: 'RAISE_NOTIFICATION' },
        ),
      clearNotification: (key: string) =>
        set(
          (state) => {
            delete state.notifications[key];
          },
          false,
          { type: 'CLEAR_NOTIFICATION' },
        ),
    })),
    {
      store: 'Module',
    },
  ),
);

export { use };
